<template>
  <div class="header clearfix" ref="oHeader">
    <div class="logo fl" @click="handleBackIndex">
      <img class="logo-img" src="../assets/images/logo.svg" alt="" v-if="isLight" key="light" />
      <img class="logo-img" src="../assets/images/logo_dark.png" alt="" v-else key="dark"/>
    </div>
    <div class="menu fr" v-clickoutside="handleClose">
      <img src="../assets/images/menu.svg" alt="" class="menu-btn" @click="isMenuShow=true" v-if="isMenuLight" key="light" />
      <img src="../assets/images/menu-dark.svg" alt="" class="menu-btn" @click="isMenuShow=true" v-else key="dark" />

      <transition name="slide-fade">
        <div class="slide-menu" v-show="isMenuShow">
          <ul class="slide-menu-list">
            <li class="slide-menu-item">
              <a :href="indexUrl" class="link">
                <div class="bar"></div>首页</a>
            </li>
            <li class="slide-menu-item slide-menu-item-haschildren" v-for="(item,index) in navList" :key="item.id" @mouseleave="handleMenu(3)">
              <a href="javascript:;" v-if="item.childList" class="link" @mouseenter="handleMenu(1)">
                <div class="bar"></div>{{item.name}}</a>
              <router-link :to="item.url" v-else class="link">
                <div class="bar"></div>{{item.name}}</router-link>
              <transition name="slideOutDown" v-if="item.childList">
                <ul class="second-menu-news" v-show="isNewsMenuShow">
                  <li class="second-menu-item" v-for="child in item.childList" :key="child.id">
                    <router-link :to="child.url" class="link">
                      <div class="bar"></div>{{child.name}}</router-link>
                  </li>
                </ul>
              </transition>
            </li>
            <!-- <li class="slide-menu-item" v-for="(item,index) in navlist" :key="index">
              <router-link :to="item.path" class="link"><div class="bar"></div>{{item.name}}</router-link>
            </li> -->
            <li class="slide-menu-item slide-menu-item-haschildren" @mouseleave="handleMenu(4)">
              <a href="javascript:;" class="link" @mouseenter="handleMenu(2)">
                <div class="bar"></div>廉正监督</a>
              <transition name="slideOutDown">
                <ul class="second-menu" v-show="isShow">
                  <li class="second-menu-item">
                    <router-link to="FAQ" class="link">
                      <div class="bar"></div>常见问题</router-link>
                  </li>
                  <li class="second-menu-item">
                    <router-link to="discreditInquiry" class="link">
                      <div class="bar"></div>违约查询</router-link>
                  </li>
                  <li class="second-menu-item">
                    <router-link to="reportOnline" class="link">
                      <div class="bar"></div>在线举报</router-link>
                  </li>
                </ul>
              </transition>
            </li>
            <li class="slide-menu-item">
              <a href="http://qingfeng.didiglobal.com/Code-of-Conduct/" class="link">
                <div class="bar"></div>行为准则</a>
            </li>
          </ul>
          <img src="../assets/images/close.svg" alt="" class="close" @click="handleClose">
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import api from "@/api/api"
import clickoutside from '@/directives/clickoutside'
import { backIndexMixin } from '@/mixins/backIndexMixin'
export default {
    mixins: [backIndexMixin],
  props: {
    isLight: {
      type: Boolean,
      default: true
    },
    isMenuLight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShow: false,
      isMenuShow: false,
      isNewsMenuShow: false,
      navList: [],
      scrollTop: null
    };
  },
  directives: { clickoutside },
  created() {
    this.getMenu()
  },
  methods: {
    getMenu() {
      api.base.menu().then(res => {
        if (res.data.code == 200) {
          this.navList = res.data.data
        }
      })
    },
    handleClose() {
      this.isMenuShow = false
    },
    handleMenu(id) {
      if (id == 1) {
        this.isNewsMenuShow = true
        this.isShow = false
      } else if (id == 2) {
        this.isShow = true
        this.isNewsMenuShow = false
      } else if (id == 3) {
        this.isNewsMenuShow = false
      } else {
        this.isShow = false
      }
    },
    handleScroll() {
      if (window.pageYOffset) {
        this.scrollTop = window.pageYOffset
      } else if (document.compatMode && document.compatMode != 'BackCompat') {
        this.scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        this.scrollTop = document.body.scrollTop
      }

      if (this.scrollTop > 20) {
        this.$refs.oHeader.className = 'header clearfix bg_fff'
      } else {
        this.$refs.oHeader.className = 'header clearfix'
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
};
</script>
<style lang="less" scoped>
.header {
  padding: 0.25rem 0.3rem 0.25rem;
  position: fixed;
  width: 100%;
  z-index: 666;
  top: 0;
  left: 0;
  background-color: #f5f5f5;
  transition: all 0.8s ease;
  font-size: 16px;
}
.bg_fff {
  background-color: #fff !important;
}
// .static-header {
//   position: static;
// }
.logo {
  height: 0.55rem;
}
.logo-img {
  height: 48px;
  width: 141px;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
   -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  right: 20rem/100;
  width: 0.2rem;
  cursor: pointer;
}
.menu-btn {
  cursor: pointer;
  width: 35rem/100;
  height: auto;
  margin-top: 0.08rem;
}
.slide-menu {
  width: 3.2rem;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 1001;
  height: 100%;
  padding-top: 1.5rem;
}

.slide-menu-item {
  margin-bottom: 56rem/100;
  overflow: hidden;
  .link {
    display: block;
    padding-left: 80rem/100;
    font-family: PingFangSC-Regular;
    font-size: 0.2rem;
    color: #ffffff;
    letter-spacing: 1.34px;
    color: #ffffff;
    position: relative;
    &:hover {
      .bar {
        // display: block;
        width: 0.5rem;
      }
    }
  }
  .bar {
    position: absolute;
    width: 0;
    height: 1px;
    background: #ffffff;
    left: 0;
    bottom: 10rem/100;
    transition: all 0.5s ease;
  }
}
.second-menu {
  margin-top: 15rem/100;
  height: 140rem/100;
}
.second-menu-news {
  margin-top: 15rem/75;
  height: 95rem/100;
}
.second-menu-item {
  font-family: PingFangSC-Regular;
  line-height: 46rem/100;
  .link {
    color: #ffffff;
    font-size: 0.18rem;
    letter-spacing: 0.85px;
  }
  .bar {
    bottom: 15rem/100;
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(3.2rem);
  opacity: 0;
}
.slideOutDown-enter-active,
.slideOutDown-leave-active {
  transition: all 0.5s ease;
}
.slideOutDown-enter,
.slideOutDown-leave-to {
  opacity: 0;
  height: 0;
}
@-webkit-keyframes slideOutDown {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@keyframes slideOutDown {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
}
</style>




// WEBPACK FOOTER //
// src/components/Header.vue